import commonMessages from '@rhg/lang/messages/common';
import { displayLocaleDateString } from '@rhg/utils/date-time';
import { isToday, isYesterday } from 'date-fns';
import { useCallback } from 'react';
import { useIntl } from 'react-intl';

export function useHumanReadable() {
    const { formatMessage } = useIntl();

    const duration = useCallback(
        (ms?: number) => {
            if (typeof ms === 'undefined') {
                return '';
            }

            const seconds = Math.floor(ms / 1000);
            const minutes = Math.floor(seconds / 60);

            if (minutes) {
                return formatMessage(commonMessages['common.min'], { minutes });
            }
            return formatMessage(commonMessages['common.sec'], { seconds });
        },
        [formatMessage]
    );

    const dateAndRelativeDay = useCallback(
        (date: Date) =>
            (isYesterday(date)
                ? formatMessage(commonMessages['common.yesterday']) + ', '
                : '') +
            (isToday(date)
                ? formatMessage(commonMessages['common.today']) + ', '
                : '') +
            displayLocaleDateString(date),
        [formatMessage]
    );

    return {
        duration,
        dateAndRelativeDay,
    };
}
